import React from 'react'

import styled, { useTheme } from 'styled-components'

import { APP_DEFAULT_STATE } from '@api/local'
import { Heading, Seperator, Spacer } from '@atoms/index'
import { ResponsivePXValue } from '@components/Theme'
import { FrozenCategoryFragment, FrozenMealDishDetailsFragment, useGetAppQuery, useGetRelatedFrozenDishesQuery } from '@hooks/api'
import { CraftDessertCard, SectionLoading } from '@molecules/index'
import { DeviceTypeEnum } from '@uctypes/api/globalTypes'

export interface CraftDessertsYouMightAlsoLikeProps {
  dish: FrozenMealDishDetailsFragment
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;

  ${ResponsivePXValue('width', { mobile: '100%', desktop: '1136px' }, { desktop: true })}
`

const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;

  ${ResponsivePXValue('margin-top', { mobile: '18px', tablet: '22px', desktop: '28px' })}

  .craft-meal-card {
    ${ResponsivePXValue('margin', { mobile: '0 0 18px', tablet: '0 0 22px', desktop: ' 0 0 28px' })}
  }
  
`

export function CraftDessertYouMightAlsoLike({ dish }: CraftDessertsYouMightAlsoLikeProps): JSX.Element {

  const { data, loading } = useGetRelatedFrozenDishesQuery({
    variables: {
      frozenCategories: dish?.frozenCategories?.map((category: FrozenCategoryFragment) => category.id),
    },
  })

  const { data: appData = { app: { ...APP_DEFAULT_STATE } } } = useGetAppQuery()
  const theme = useTheme()

  const relatedFilter = (relatedDish: FrozenMealDishDetailsFragment) => relatedDish.id !== dish?.id
  const craftDesserts = data?.related?.list.filter(relatedFilter).slice(0, appData.app.deviceType === DeviceTypeEnum.TABLET ? 4 : 4) || []

  let craftDessert: FrozenMealDishDetailsFragment

  return (
    <Choose>
      <When condition={craftDesserts.length > 0}>
        <Container id='craftDessertsYouMightLike'>
          <Heading align='center' variant='misc' color={theme.colors.slates.bitter}>You might also like</Heading>
          <Spacer universal='8px' />
          <Seperator align='center' />
          <CardContainer>
            <For each='craftDessert' of={craftDesserts || []}>
              <CraftDessertCard
                className='craft-meal-card'
                key={craftDessert.id}
                craftDessertMeal={craftDessert} />
            </For>
          </CardContainer>
        </Container>
      </When>
      <When condition={loading}>
        <SectionLoading />
      </When>
      <Otherwise>

      </Otherwise>
    </Choose>
  )

}
